import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { apiClient } from '@/lib/apiClient';
import type { BulkJob } from '../types/notificationMessage';

const call = apiClient.request as unknown as (...a: unknown[]) => Promise<[unknown, unknown]>;

export const bulkJobQueryKey = (jobId: string | null) =>
  ['admin', 'notification-bulk-job', jobId] as const;

export const useBulkJobQuery = (jobId: string | null): UseQueryResult<BulkJob, Error> =>
  useQuery<BulkJob>({
    queryKey: bulkJobQueryKey(jobId),
    enabled: Boolean(jobId),
    queryFn: async () => {
      const [data] = await call('get', `/admin/v1/notification/jobs/${jobId}`);
      return data as BulkJob;
    },
    refetchInterval: (query) => {
      const status = query.state.data?.status;
      return status === 'COMPLETED' || status === 'FAILED' ? false : 2000;
    },
  });
